import React from 'react';
import styles from './facts.module.scss';
import {Col, Row} from "react-bootstrap";

import {Fact} from "../fact/fact";
import {connect} from "react-redux";

const Facts = ({ bgImage = '', className, projects=[], wording, totalCollected }) => {

    let successProjects = projects?.filter(el => (el.status === 'completed' || (el.status === 'failed' && el.raised >= el.goal * 0.2 && el.raised < el.goal * 0.5))) || []
    let failedProjects = projects?.filter(el => ((el.status === 'failed' && el.raised < el.goal * 0.2) || el.status === 'refund')) || []

    const labeledFacts = [
        {
            "title": wording['fact1'],
            "percentage": successProjects.length
        },
        {
            "title": `${wording['fact2']}, €`,
            "percentage": totalCollected
        },
        {
            "title":  wording['fact3'],
            "percentage": projects?.filter(project => project.status === 'approved').length
        },
        {
            "title": wording['fact4'],
            "percentage": failedProjects.length
        }
    ]

    const getFacts = () => {
        return labeledFacts.map((fact, index) => (
            <Col md={3} sm={6} xs={12} key={index + fact.percentage}>
                <Fact title={fact.title} percentage={fact.percentage} className={className}></Fact>
            </Col>
        ))
    }

    return (
        <div className={`${styles.facts}`} style={{backgroundImage: bgImage ? `url(${bgImage})` : ''}}>
            <Row className={styles.content}>
                {getFacts()}
            </Row>
        </div>
    )
}

const mapStateToProps = ({  projects: { projects }, system: { wording, totalCollected } }) => {
    return { projects, wording, totalCollected };
};

export default connect(mapStateToProps)(Facts);
